<section *ngIf="!loading" aria-labelledby="dashboard-title">
  <header class="dashboard-heading">
    <p class="portal-eyebrow">Staff workspace</p>
    <h1 id="dashboard-title">Licensing administration</h1>
    <p>Manage facility licenses, review applications, and follow up on your assignments.</p>
  </header>
  <div class="program-grid">
    <mat-card class="program-card">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">home_health</mat-icon>
        <h2>In-home care</h2>
        <p>Review applications and manage agency licenses and changes.</p>
        <a mat-flat-button color="primary" routerLink="/in-home-care/manage">Manage in-home care <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
    <mat-card class="program-card" *ngIf="environment.displayHemotech">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">bloodtype</mat-icon>
        <h2>Hemodialysis technicians</h2>
        <p>Review technician applications and manage certifications.</p>
        <a mat-flat-button color="primary" routerLink="/hemo-tech/manage">Manage technicians <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
    <mat-card class="program-card" *ngIf="environment.displayHospitals">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">local_hospital</mat-icon>
        <h2>Hospitals and SICFs</h2>
        <p>Manage hospitals, special inpatient care facilities, and their service locations.</p>
        <a mat-flat-button color="primary" routerLink="/hospital/manage">Manage hospitals / SICFs <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
  </div>
</section>
<div *ngIf="loading" class="portal-loading" role="status">
  <p>Loading your workspace…</p>
  <mat-progress-bar mode="indeterminate" aria-label="Loading your workspace"></mat-progress-bar>
</div>
